import Alpine from "alpinejs";
import { waitForAlpineStore } from "../waitForAlpineStore";
import { Tab } from "bootstrap";

export const uiTweaks = {
  init() {
    this._setBaseFontSize();
    // waitForAlpineStore('pwa').then((pwa) => {
    //     if(pwa.isInstalled) {
    //         this.disableRightClickOnPWA();

    //     }
    // })
  },

  _setBaseFontSize() {
    waitForAlpineStore("userPreferences").then((store) => {
      Alpine.effect(() => {
        let baseFontSize = store.fontSize;
        console.log("Setting Base Font Size to " + baseFontSize);
        document.body.style.setProperty(
          "--bs-body-font-size",
          baseFontSize + "px"
        );
        document.documentElement.style.fontSize = baseFontSize + "px";
      });
    });
  },

  disableRightClickOnPWA() {
    document.addEventListener("contextmenu", function (event) {
      event.preventDefault();
    });
  },

  disableSelectOnPWA() {
    // need to discuss
  },

  
};
